<template>
  <div>
    <div class="row">
        <h2>Add Words to <b>({{this.group.lexicon_description}})</b></h2>
    </div>
    <div class="row float-right">
      <div class="col-md-12">
        <label class="btn btn-danger" @click.stop="cancel($event)">
          Cancel
        </label>&nbsp;

        <label v-if="this.words.length > 0" class="btn btn-success" @click.stop="onSaveWords($event)">
          Save
        </label>&nbsp;
      </div>
    </div>
    <div>
      <br />
      New Word: <input style="width: 20%;" type="text" @keyup.enter="addWord()" v-model="newWordVal" />
      <br /><br />
      <div v-if="this.displayFlash" class="alert alert-danger" role="alert">
        {{flashMsg}}
      </div>

      <div v-if="this.words.length === 0" class="d-flex justify-content-center">
        No words added yet, type a word in the above text field and hit enter when you
        finish adding it, this will add the new word to the list of words to be submitted.
      </div>

      <div v-if="this.words.length > 0" class="d-flex justify-content-center">
        <table>
          <tr v-for="word in words" v-bind:key="word">
              <td><h2>{{word}}</h2></td>
              <td><a style="color: blue; cursor: pointer;" @click="deleteWord(word)">Delete</a></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import router from '../router'

export default {
  name: 'LexiconWordsAdd',
  data: function () {
    return {
      group: '',
      groupId: this.$route.params.id,
      words: [],
      newWordVal: '',
      displayFlash: false,
      flashMsg: ''
    }
  },
  mounted: function () {
    if (!this.$route.params.id) {
      router.push({ name: 'Lexicons' })
    } else {
      apiClient.get('/api/lexicons/item/' + this.$route.params.id).then((response) => {
        this.group = response.data.group[0]
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  },
  methods: {
    cancel: function () {
      this.$router.go(-1)
    },
    addWord: function () {
      if (!this.newWordVal.trim()) {
        this.flashMsg = 'Empty values are not allowed!'
        this.displayFlash = true
        setTimeout(() => {
          this.displayFlash = false
        }, 10000)

        return
      }

      let isDouplicate = false
      for (let i = 0; i < this.words.length; i++) {
        if (this.words[i] === this.newWordVal.trim()) {
          isDouplicate = true
          this.flashMsg = 'Douplicate words are not allowed!'
          this.displayFlash = true
          setTimeout(() => {
            this.displayFlash = false
          }, 10000)
        }
      }

      if (!isDouplicate) {
        this.words.push(this.newWordVal)
      }
      this.newWordVal = ''
    },
    deleteWord: function (word) {
      this.words.forEach((w, k) => {
        if (w === word) {
          this.words.splice(k, 1)
        }
      })
    },
    onSaveWords: function () {
      apiClient.post('/api/lexicons/word/add', {
        word: this.words.join(','),
        group_id: this.groupId,
        guides: '',
        phonemes: '',
        colors: ''
      }).then((response) => {
        if (response.status === 201) {
          this.renderProps = []
          console.log(this.saveState)
          this.$router.go(-1)
        } else {
          this.saveState = 2
          this.renderProps = []
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  }
}
</script>
